module.exports = __webpack_public_path__ + "img/tl.2f016219.svg";